import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/** `?focus=<anchor>`: scrolls the element with that id into view and outlines it
 * (token colour, no box-shadow). `ready` delays the lookup until the anchors exist. */
export function useFocusHighlight(ready = true): string | null {
  const [params] = useSearchParams();
  const focus = params.get("focus");
  useEffect(() => {
    if (!focus || !ready) return;
    const el =
      document.getElementById(`setting-${focus}`) ?? document.getElementById(`panel-${focus}`);
    if (!el) return;
    if (typeof el.scrollIntoView === "function") el.scrollIntoView({ block: "center" });
    el.setAttribute("data-focused", "true");
    el.style.outline = "2px solid var(--d-fg)";
    el.style.outlineOffset = "2px";
    return () => {
      el.removeAttribute("data-focused");
      el.style.outline = "";
      el.style.outlineOffset = "";
    };
  }, [focus, ready]);
  return focus;
}
